import { defineMessages } from 'react-intl';

export default defineMessages({
    confirmationSuccess: {
        id: 'fnol.adac.confirmation-page.Submitted successfully',
        defaultMessage: 'Submitted successfully'
    },
    confirmationClose: {
        id: 'fnol.adac.confirmation-page.Close',
        defaultMessage: 'Close'
    },
    pageHeaderSubTitle: {
        id: 'fnol.adac.confirmation-page.Your request has been received',
        defaultMessage: 'Your request has been received'
    },
    statusDot: {
        id: 'fnol.adac.confirmation-page.confirmation.dot',
        defaultMessage: '●   '
    },
    statusMessage: {
        id: 'fnol.adac.confirmation-page.In processing by ADAC',
        defaultMessage: 'In processing by ADAC'
    },
    nextStep: {
        id: 'fnol.adac.confirmation-page.Next step',
        defaultMessage: 'Next step'
    },
    callbackTitle: {
        id: 'fnol.adac.confirmation-page.Recall of the ADAC',
        defaultMessage: 'Recall of the ADAC'
    },
    callbackInformation: {
        id: 'fnol.adac.confirmation-page.Callback information',
        defaultMessage: 'We will call you back in the next { callbackOption }. Please keep your phone free.'
    },
    claimNumberLabel: {
        id: 'fnol.adac.confirmation-page.Claim number',
        defaultMessage: 'Claim number will be communicated at the next contact with ADAC'
    }
});
